<template>
    <Link v-if="href" :href="href" :class="linkClasses">
        <slot></slot>
    </Link>

    <button v-else :type="type" :class="buttonClasses">
        <slot></slot>
    </button>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        color: {
            type: String,
            default: 'green',
        },
        href: String,
    },

    components: {
        Link,
    },

    computed: {
        colorLinkClasses() {
            if (this.color == 'green') {
                return 'bg-green hover:bg-green-dark focus:bg-green-dark';
            } else if (this.color == 'red') {
                return 'bg-red-500 hover:bg-red-600 focus:bg-red-600';
            } else if (this.color == 'blue') {
                return 'bg-blue-500 hover:bg-blue-600 focus:bg-blue-600';
            } else if (this.color == 'yellow') {
                return 'bg-yellow-500 hover:bg-yellow-600 focus:bg-yellow-600';
            }
        },
        
        linkClasses() {
            let baseClasses = 'rounded shadow-md text-white font-bold text-xs uppercase px-4 py-2';

            return `${baseClasses} ${this.colorLinkClasses}`;
        },

        colorButtonClasses() {
            if (this.color == 'green') {
                return 'bg-green hover:bg-green-dark active:bg-green-dark focus:ring-green';
            } else if (this.color == 'red') {
                return 'bg-red-500 hover:bg-red-600 active:bg-red-600 focus:ring-red-500';
            } else if (this.color == 'blue') {
                return 'bg-blue-500 hover:bg-blue-600 active:bg-blue-600 focus:ring-blue-500';
            } else if (this.color == 'yellow') {
                return 'bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-600 focus:ring-yellow-500';
            }
        },

        buttonClasses() {
            let baseClasses = 'inline-flex items-center px-4 py-2 rounded shadow-md text-white font-bold text-xs uppercase tracking-widest focus:outline-none focus:ring focus:ring-opacity-50 disabled:opacity-25 disabled:cursor-not-allowed transition border-none';

            return `${baseClasses} ${this.colorButtonClasses}`;
        },
    },
}
</script>
